import { Card, Flex, Space, Typography } from "antd";
import { disableStoreReasonsObject } from "../../../constants/disableStoreReasons";

const { Text } = Typography;

export default function DeliverySettingsDisableDetails({ deliveryService, store }) {
  return (
    <Card
      variant="borderless"
      size="small"
      style={{
        width: "100%",
        borderRadius: "0 0 15px 15px",
        border: 0,
        alignContent: "end",
        top: "5px"
      }}
    >
      <Flex vertical align="center">
        <Text type="danger" strong style={{ fontSize: "18px" }}>Service is currently disabled.</Text>
        <Space>
          <Space.Compact direction="vertical">
            <Space>
              <Text strong>Reason:</Text>
              <Text>{disableStoreReasonsObject[store.deliverySettings[deliveryService].reason]}</Text>
            </Space>
          </Space.Compact>
        </Space>
        <Space>
          <Space.Compact direction="vertical">
            <Space>
              <Text strong>Notes:</Text>
              <Text>{store.deliverySettings[deliveryService].note}</Text>
            </Space>
          </Space.Compact>
        </Space>
      </Flex>
    </Card>
  );
};